// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"25d7c052","521":"6f95586e"}[chunkId] + ".chunk.js";
};